import dayjs from 'dayjs';

const formatTimestampToDate = (timestamp = 0) => {
  const date = new Date(timestamp?.seconds * 1000);
  return {
    date: dayjs(date).format('DD/MM/YYYY'),
    time: dayjs(date).format('HH:mm'),
  };
};

export default formatTimestampToDate;
